import { render, staticRenderFns } from "./RescouceManage.vue?vue&type=template&id=674c3f6c&scoped=true&"
import script from "./RescouceManage.vue?vue&type=script&lang=js&"
export * from "./RescouceManage.vue?vue&type=script&lang=js&"
import style0 from "./RescouceManage.vue?vue&type=style&index=0&id=674c3f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c3f6c",
  null
  
)

export default component.exports